import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import AccountNavigator from './AccountNavigator';
import AppNavigator from './AppNavigator';

import CommentsSeedScreen from '../screens/CommentsSeedScreen';
import MapVisor from '../components/MapVisor';

const Stack = createStackNavigator();

export default function NoBottonTabNavigator() {
  return (
    <Stack.Navigator >
      <Stack.Screen name="AppNavigator" component={AppNavigator} options={{ headerShown: false }} />
      <Stack.Screen name="My Actions" component={AccountNavigator} options={{ headerShown: false }} />
      <Stack.Screen name="Comments Seeds" component={CommentsSeedScreen} />
      <Stack.Screen name="Map" component={MapVisor} options={{ headerShown: false }}/>

      {/* <Stack.Screen name="Account" component={AccountScreen} /> */}



    </Stack.Navigator>
  );
}
